export default __webpack_public_path__ + "static/media/Customer-Acquisition.27ba8243.png";